import moment from 'moment';

export const getTimeFromStartTime = (time, format) => {
  if (!time) {
    return null;
  }

  return moment
    .utc()
    .startOf('day')
    .add(time, 'minutes')
    .format(format);
};

export const getDayOfTheWeek = (index) =>
  moment(index, 'e')
    .startOf('week')
    .isoWeekday(index)
    .format('ddd');

export const getFullDayOfTheWeek = (index) =>
  moment(index, 'e')
    .startOf('week')
    .isoWeekday(index)
    .format('dddd');

export const getDateForScreenReader = (date) =>
  moment(date).format('dddd, MMMM Do');

export const groupSlotsByDate = (slots) =>
  slots.reduce((arr, item) => {
    const { date } = item;
    if (!arr[date]) {

      arr[date] = [item];
      return arr;
    }
    arr[date].push(item);
    return arr;
  }, {});

export const getDatesToDisplay = ({ format, startDate, numDaysToDisplay }) => {
  if (!startDate || !moment.isMoment(startDate)) {
    return {
      dayMoments: [],
      formattedDays: [],
    };
  }

  const startOfWeek = startDate.startOf('week').startOf('day');

  const dayMoments = Array.from(
    { length: numDaysToDisplay },
    (_, i) => startOfWeek.clone().add(i, 'day'),
  );

  let formattedDays = [];
  if (format) {
    formattedDays = dayMoments.map((dayMoment) => dayMoment.format(format));
  }

  return {
    dayMoments,
    formattedDays,
  };
};

export const getActiveSlots = ({ startDate, slots, numDaysToDisplay }) => {
  if (!startDate) {
    return null;
  }
  const groupedSlots = groupSlotsByDate(slots);
  const { formattedDays } = getDatesToDisplay({ format: 'YYYY-MM-DD', startDate, numDaysToDisplay });
  const active = formattedDays.reduce((arr, day) => {

    arr[day] = groupedSlots[day] || [];
    return arr;
  }, {});
  const sortedActive = {};
  Object.keys(active).forEach((key) => {
    const sorted = active[key].sort((a, b) => a.time - b.time);
    sortedActive[key] = sorted;
  });
  return sortedActive;
};

export const getHoursToDisplay = (start, end) => {
  if (start === 0 && end === 0) {
    return 'Closed';
  }
  const format = 'h:mm a';
  return `${getTimeFromStartTime(start, format)} - ${getTimeFromStartTime(
    end,
    format,
  )}`;
};

export const getHoursForScreenReader = (start, end) =>
  getHoursToDisplay(start, end)
    .replace('-', 'to')
    .replace(/:00/g, '');

export const getNearestDateWithSlots = (slots) => {
  const groupedSlots = groupSlotsByDate(slots);
  const date = Object.keys(groupedSlots).find((d) => groupedSlots[d].length > 0);
  return date;
};
